import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "./apiClient";

/**
 * TLS — admin API `/admin/api/v1/tls` (ROLE_ADMIN). Status (zdroj/protokoly/porty/
 * certifikát) + akce renew (ACME) / reload bundle. Admin twin TlsAdminController.
 */
const BASE = "/admin/api/v1/tls";

export interface TlsCert {
  source: string;
  subject: string;
  issuer: string;
  notBefore: string;
  notAfter: string;
  serial: string;
  fingerprint: string;
  installedAt: string;
  active: boolean;
  notes: string | null;
}

export interface TlsStatus {
  source: string;
  httpsActive: boolean;
  listenPort: number;
  protocols: string | null;
  httpPort: number;
  httpsPublicPort: string | null;
  hsts: boolean;
  allowHttp: boolean;
  redirectHttp: boolean;
  forwardHeaders: string;
  keystorePath: string | null;
  keystoreType: string | null;
  acmeEnabled: boolean;
  acmeDomains: string[];
  renewalDays: number;
  active: TlsCert | null;
  history: TlsCert[];
}

export interface TlsActionResult {
  success: boolean;
  message: string;
}

export function useTlsStatus() {
  return useQuery({ queryKey: ["tls", "status"], queryFn: () => apiFetch<TlsStatus>(`${BASE}/status`) });
}

export function useTlsRenew() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<TlsActionResult>(`${BASE}/renew`, { method: "POST" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["tls"] }),
  });
}

export function useTlsReload() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<TlsActionResult>(`${BASE}/reload`, { method: "POST" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["tls"] }),
  });
}
